import React, { Component } from "react";
import { Colors } from "./../../utils/variables";

export default class Merch extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    return (
      <div
        className="primary-background"
        style={{
          backgroundColor: Colors.primaryDark,
          backgroundImage: 'url("/images/topo-texture.png")'
        }}
      >
        <div className="large-padding centered-text">
          <div className="max-width-container" style={{ maxWidth: 1200, marginTop: '5vh' }}>
            <h1 style={{ color: "#fff" }}>{"Merch"}</h1>
            <p className="subheading" style={{ color: "#fff" }}>
              {"Being rad comes with a first step of looking fresh, grab a Peak Pursuits tank and show your support for the event!"}
            </p>
            <a
              style={{ textDecoration: "none" }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://square.link/u/aFDuVMYh?src=sheet"
            >
              <div className="card primary-background" style={{ marginTop: '5vh', padding: 30 }}>
                <div className="row">
                  <div className="small-12 medium-6">
                    <img className="full-width" src="/images/shirt.jpg" alt="Peak Pursuits Tank" />
                  </div>
                  <div className="small-12 medium-6 small-padding row" style={{ alignItems: "center" }}>
                    <div className="full-width">
                      <h2 className="white" style={{ textDecoration: "none" }}>
                        {"Peak Pursuits Tank"}
                      </h2>
                      <div
                        style={{
                          marginBottom: 20,
                          backgroundColor: Colors.tertiary,
                          color: Colors.white,
                        }}
                        className="button"
                      >
                        Buy Now
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}
